import { render, staticRenderFns } from "./ButtonCopyOther.vue?vue&type=template&id=59c4c036&scoped=true"
import script from "./ButtonCopyOther.vue?vue&type=script&lang=js"
export * from "./ButtonCopyOther.vue?vue&type=script&lang=js"
import style0 from "./ButtonCopyOther.vue?vue&type=style&index=0&id=59c4c036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c4c036",
  null
  
)

export default component.exports